@if (visible) {
<p-message severity="warn" [closable]="false" styleClass="maintenance-banner">
  <div class="banner-content">
    <i class="pi pi-exclamation-triangle banner-icon"></i>
    <div class="banner-text">
      <strong>{{ 'scheduled_maintenance_banner_title' | translate }}</strong>
      <p>
        <span [innerHTML]="safeMaintenanceBannerMessage"></span>
      </p>
    </div>
  </div>
</p-message>
}